import React from "react";
import { ThemeProvider } from "styled-components";
import GlobalStyle from "./styles/GlobalStyles";
import { frusterTheme } from "./styles/Theme";
import AppRouter from "./pages/AppRouter";
import APIClient from "./networking/APIClient";

export const apiClient = new APIClient(process.env.REACT_APP_API_ROOT || "http://localhost:3100/api");

const App: React.FC = () => {
  return (
    <ThemeProvider theme={frusterTheme}>
      <>
        <GlobalStyle />
        <AppRouter />
      </>
    </ThemeProvider>
  );
};

export default App;
